import { useMemo } from 'react'

import { Flex } from 'antd'

import { FormSelectLoadingPlaceholder } from 'src/components/form/shared/LoadingPlaceholder'
import Text, { TextSize } from 'src/components/Typography/Text'

import { EntityVersionFragment } from '../../../types/graphql'
import { useGetEntityVersionsById } from '../../fetch/entityVersions'

type Props = {
  entityVersionIds: number[]
  size?: TextSize
}
const EntityVersionFieldDisplay = ({ entityVersionIds, size }: Props) => {
  const { entityVersions, isLoading: isLoadingEntityVersions } =
    useGetEntityVersionsById(entityVersionIds)
  const entityVersionsById = useMemo(
    () => new Map<number, EntityVersionFragment>(entityVersions.map((ev) => [ev.id, ev])),
    [entityVersions]
  )

  if (isLoadingEntityVersions) {
    return <FormSelectLoadingPlaceholder />
  }
  return (
    <Flex vertical>
      {entityVersionIds.map((id) => (
        <Text key={id} size={size}>
          {entityVersionsById.get(id)?.entity?.name}
        </Text>
      ))}
    </Flex>
  )
}

export default React.memo(EntityVersionFieldDisplay)
